"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createToError = exports.InternalError = void 0;
var InternalError = /** @class */ (function () {
    function InternalError(status, code, message) {
        this.status = status;
        this.code = code;
        this.message = message;
        this.name = this.constructor.name;
        this.stack = new Error().stack;
    }
    return InternalError;
}());
exports.InternalError = InternalError;
InternalError.prototype = new Error();
var createToError = function (parseInternalError, parseNativeError) { return function (error) {
    error = error.response || error;
    return Promise.reject(error instanceof InternalError
        ? parseInternalError(error)
        : parseNativeError(error));
}; };
exports.createToError = createToError;
//# sourceMappingURL=internal-error.js.map